import React from "react";
import monitor from "../img/monitor.jpg";
import TypingEffect from "./TypingEffect";
import MotivacionalSentences from "./MotivacionalSentences";


const Header = () =>{
    const texts = ["Jasmany Zambrano", "a Web Developer", "a JAVA Developer","a Full-Stack" ,"an Enthusiast" ];
    return(
        <header className="header">
            <div class="bg-image">
                <div class="bg-text">
                    <TypingEffect texts={texts}/>
                </div>
            </div>
            <div className="header-right">
                <img src={monitor} alt="monitor"></img>
                <div className="dch-bajo">
                   <MotivacionalSentences></MotivacionalSentences>
                </div>
            </div>
        </header>
    );
}
export default Header;